import React from 'react';
import { Tag } from 'antd';
import { RosterVersions } from 'views/Roster/Versions';
import { ItemTags } from 'views/shared/ItemTags';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { canViewOptimiser } from 'library/optimiser';
import RosterInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    commands: {
      showDelete: false
    },
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '300px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => {
          try {
            const optimiserEnabled = canViewOptimiser();
            if (optimiserEnabled && record && record.used_by_optimiser) {
              return (
                <span>
                  {text}
                  <Tag color="green" style={{ marginLeft: 8 }}>Optimiser</Tag>
                </span>
              );
            }
          }
          catch (e) {
            // Fall through to default
          }
          return text;
        }
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the roster
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Rosters'
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Roster',
    defaultKey: '1',
    title: 'Roster',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <RosterInput
            {...props}
            title="Roster"
          />
        ),
        forceRender: true
      },
      {
        key: 1,
        title: 'Versions',
        component: props => (
          <RosterVersions
            {...props}
            title="Versions"
          />
        )
      },
      {
        key: 2,
        title: 'Tags',
        component: props => (
          <ItemTags
            {...props}
            themeName={THEME_NAMES.roster}
          />
        )
      }
    ]
  }
};

export default config;
